import { forwardRef } from 'react';
import cn from 'classnames';

export default forwardRef(function SearchInput({
  autofocus,
  disabled,
  focusIndex,
  handleFocus,
  handleInput,
  onChange,
  inputAriaLabel,
  inputId,
  isOpen,
  isTypeAhead,
  placeholder,
  value,
  className,
  ...rest
}, ref) {
  const activeDescendantValue = () => {
    if (focusIndex > -1) {
      return `suggestion-${focusIndex}`;
    }
    return null;
  };

  return (
    <input
      aria-activedescendant={isTypeAhead ? activeDescendantValue() : null}
      aria-autocomplete={isTypeAhead ? 'both' : null}
      aria-describedby={isTypeAhead ? 'search-helper' : null}
      aria-label={inputAriaLabel === '' ? null : inputAriaLabel}
      aria-controls={isTypeAhead ? 'searchSuggestions' : null}
      aria-expanded={isTypeAhead ? isOpen : null}
      autoComplete={isTypeAhead ? 'off' : 'on'}
      autoFocus={autofocus}
      className={cn(
        'lds-text-field',
        'lds-search-field',
        className
      )}
      disabled={disabled}
      id={inputId}
      name={inputId}
      onChange={onChange}
      onFocus={handleFocus}
      onInput={handleInput}
      placeholder={placeholder}
      ref={ref}
      role={isTypeAhead ? 'combobox' : 'searchbox'}
      type="search"
      value={value}
      {...rest}
    />
  );
});
